import {
  Button,
  Dialog,
  DialogTitle,
  Paper,
  TextField,
  Grid,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setIsLoading, setUserToken } from "../../../../../features/userSlice";
import { MetaEntitiesEndPointLogic } from "../../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";

interface ProductTypeProps {
  open: boolean;
  handleClose: () => void;
  SetProductTypeName: any;
  productTypeName: any;
  selectedShareuid: any;
  setSelectedSharedUid: any;
  setMetaProductType: any;
  metaProductType: any;
  selectedRowData: any;
  setSelectedRowData: any;
}

function EditProductTypeModal({
  open,
  handleClose,
  productTypeName,
  SetProductTypeName,
  selectedShareuid,
  selectedRowData,
}: ProductTypeProps) {
  const token = useSelector(setUserToken);
  const oauthTokenHeader = token?.payload?.user?.userToken;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const UpdateNewProductType = async () => {
    const data = {
      type_name: productTypeName,
    };
    try {
      setIsLoading(true);
      setLoading(true);
      if (oauthTokenHeader) {
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.updateMetaProductType(
          oauthTokenHeader,
          data,
          selectedShareuid
        );
      } else {
        throw new Error(
          "User doesn't have permissions to create new product type"
        );
      }
      if (oauthTokenHeader) {
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.getMetaProductType(
          oauthTokenHeader,
          dispatch
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      setLoading(false);
      handleClose();
      await MetaEntitiesEndPointLogic.getMetaProductType(
        oauthTokenHeader,
        dispatch
      );
    }
  };

  useEffect(() => {
    if (oauthTokenHeader) {
      SetProductTypeName(selectedRowData?.type_name);
    }
  }, [selectedRowData, oauthTokenHeader, SetProductTypeName]);

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
        >
          <Paper sx={{ padding: "16px 24px 20px 24px" }}>
            <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
              Edit New Product Type
            </DialogTitle>
            <Typography sx={{ mb: 1 }}>Details</Typography>
            <Grid container mt={0} columnSpacing={3}>
              <Grid item xs={12}>
                <TextField
                  value={productTypeName}
                  onChange={(e) => SetProductTypeName(e.target.value)}
                  id="outlined-multiline-flexible"
                  label="Product Type *" // Set your label here
                  placeholder="Enter unique Product Type Name" // Set your placeholder here
                  color="secondary"
                  size="small"
                  fullWidth
                />
              </Grid>
            </Grid>
            <Typography
              sx={{ fontSize: "12px", marginTop: "8px", color: "#00000099" }}
            >
              This is a mandatory field.
            </Typography>

            <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
              <Button color="secondary" onClick={handleClose} sx={{ mr: 1 }}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="secondary"
                disabled={!productTypeName}
                onClick={UpdateNewProductType}
                data-tracker="235"
              >
                Save changes <SaveOutlinedIcon sx={{ ml: 1 }} />
              </Button>
            </Stack>
          </Paper>
        </Dialog>
      )}
    </>
  );
}

export default EditProductTypeModal;
